import { render } from "./SplitHeader.vue?vue&type=template&id=2f808f8e&scoped=true"
import script from "./SplitHeader.vue?vue&type=script&lang=js"
export * from "./SplitHeader.vue?vue&type=script&lang=js"

import "./SplitHeader.vue?vue&type=style&index=0&id=2f808f8e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f808f8e"]])

export default __exports__